/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useGeneralService } from "../../../services/generalService";
import { toReversedHelper } from "../../../helpers/general.js";
import { useUserContext } from "../../../contexts/userContext";
import { useLabelService } from '../../../services/labelService';
import { useSpinnersContext } from "../../../contexts/spinnersContext";

/* Components */
import UCSelect from "../../ucselect";
import Skeleton from 'react-loading-skeleton';
import UCAutocomplete from "../../ucautocomplete";

/* Styles */
import styles, {rolesSelect} from "./styles.js"


const messages = defineMessages({
  peopleSearchAutocompleteLabel: {
    id: 'people.searchAutocompleteLabel'
  },
})

const GridFilters = (params) => {
  const { response, gridOptions, setGridOptions, search, type, disabled, optionsStyling, inputWrapperStyling, hide = false, className } = params
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const spinners = useSpinnersContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const intl = useIntl();

  const [options, setOptions] = useState(null);
  const [roles, setRoles] = useState([]);
  const [labels, setLabels] = useState([]);
  const [errorResponse, setErrorResponse] = useState(false);
  const [resultTotal, setResultTotal] = useState(undefined);

  const { getRoles } = useGeneralService();
  const { getLabels } = useLabelService();

  const getOptions = async (term, page = 1) => {
    const response = await search(term, page)
    if (!response) {      
      setErrorResponse(true)
      setOptions(null)
      setResultTotal(undefined)
    } else if (term.length < 3 && ( type !== "COMPANIES" && type !== "PEOPLE_AADMIN" && type !== "PEOPLE" && type !== "GUEST")) {
      setErrorResponse(false)
      setOptions(null)
      setResultTotal(undefined)
    } else {
      const companies = response?.companies ?? response;
      setErrorResponse(false)
      setOptions(companies)
      if (response?.resultTotal !== undefined) setResultTotal(response.resultTotal);
    }
  }

  useEffect(() => {
    (async () => {
      if (response?.filters?.find(elem => elem.filterType === "ROLE") && roles.length === 0) {
        const responseRoles = await getRoles();
        if (responseRoles) {
          let rolesArray = [{ value: '', label: <FormattedMessage id="people.allRoles" /> }];
          let rolesArrReversed = toReversedHelper(responseRoles?.roles)
          
          rolesArrReversed?.map(roleId => {
            rolesArray.push({value: roleId, label: <FormattedMessage id={`roles.${roleId}.${providerCode}`} />})
          })
          setRoles(rolesArray);
        }
      }

      if (!spinners["guestProfilesGridSpinner"] && response?.filters?.find(elem => elem.filterType === "LABEL")) {
        const responseLabels = await getLabels("");
        if (responseLabels) {
          const labelsArray =  responseLabels?.map(item => {
            return {value: item?.labelId, label: item.label}
          })
          const parsedLabels = [
            ...[{ value: '', label: <FormattedMessage id="guest.allLabels" /> }],
            ...labelsArray
          ]
          setLabels(parsedLabels);
        }
      }
    })();
  }, [response, spinners["guestProfilesGridSpinner"]]);

  const onSelectOption = (item) => {
    console.log(item)
  }

  return (
    !hide &&
    <div className={classes.peopleFilters}>
      {
        search &&
        <UCAutocomplete
          options={options}
          getOptions={getOptions}
          onSelectOption={onSelectOption}
          type={type}
          disabled={disabled}
          errorResponse={errorResponse}
          optionsStyling={optionsStyling}
          className={className}
          inputWrapperStyling={inputWrapperStyling}
          ariaLabel={intl.formatMessage(messages.peopleSearchAutocompleteLabel)}
          resultTotal={resultTotal}
        />
      }
      {
        response?.filters?.find(elem => elem.filterType === "ROLE")
          ? ( roles?.length > 0
              ?  <UCSelect
                styles={{...rolesSelect(theme)}}
                className={classes.roles}
                // displayName={<FormattedMessage id="people.allRoles" />}
                defaultValue={{value: '', label: <FormattedMessage id="people.allRoles"/>}}
                options={roles}
                disabled={disabled}
                onChange={(item) => setGridOptions({
                  ...gridOptions,
                  page: 1,
                  filters: {
                    ...gridOptions.filters,
                    ROLE: [item.value]
                  }
                })}
              />
              :
              <Skeleton
                count={1}
                className={classes.headerSk1}/>
          )
          :null
      }
      {
        response?.filters?.find(elem => elem.filterType === "LABEL") && roles &&
        <UCSelect
          styles={{...rolesSelect(theme)}}
          className={classes.roles}
          defaultValue={{value: '', label: <FormattedMessage id="guest.allLabels"/>}}
          options={labels}
          disabled={disabled}
          onChange={(item) => setGridOptions({
            ...gridOptions,
            page: 1,
            filters: {
              ...gridOptions.filters,
              LABEL: [item.value]
            }
          })}
        />
      }
    </div>
  )
}

export default GridFilters;
